define([
    'product-detail/store',
    'common/utils'
], function(
    Store,
    Utils
){
    return {
        data: function(){
            return {
                product: {}
            };
        },
        computed: {
            spu: function(){
                return this.product.spu || {};
            },
            spuExtra: function(){
                return this.product.spuExtra || {};
            },
            spuExtraBase: function(){
                return this.spuExtra.basic || {};
            },
            bestBuy: function(){
                return this.product.bestBuy || [];
            },
            spuBase: function(){
                return this.spu.base || {};
            },
            selectedSku: function(){
                return this.product.selectedSku || {};
            },
            selectedSkuExtra: function(){

                console.log(this.product.selectedSkuExtra)
                return this.product.selectedSkuExtra || {};
            },
            category: function(){
                return this.product.category;
            },
            isFurniture: function(){
                return this.category === 'furniture' || this.category === 'ymb';
            },
            isYmb: function(){
                return this.category === 'ymb';
            },
            isGrocery: function(){
                return this.category === 'grocery';
            },
            bgColor: function(){
                return this.selectedSkuExtra.bgColor || '';
            },
            bgColorBase64: function(){
                return this.selectedSkuExtra.bgColorBase64 || '';
            },
            skuSpec: function(){
                return this.product.skuSpec || [];
            },
            categorySpec: function(){
                return this.spu.categorySpec || [];
            },
            categorySpecValue: function(){
                return this.spu.categorySpecValue || {};
            },
            ymbLegs: function(){
                return this.product.ymbLegs || [];
            },
            moduleConfig: function(){
                return this.spuExtraBase.moduleConfig || {};
            }
        },
        methods: {
            init: function(){
                this.product = Store.getProduct();
            },
            selectSpec: function(bom, val){
                console.log(1111111111);
                return this.product.selectSpec(bom, val);
            },
            isSpecActive: function(bom, val){
                return !!_.find(this.skuSpec, {bom: bom, val: val});
            },
            canSelectSpec: function(bom, val){
                console.log(222222222);
                return this.product.canSelectSpec(bom, val);
            },
            canSelectSpecPrev: function(bom, val){
                return this.product.canSelectSpecPrev(bom, val);
            },
            ln2br: Utils.ln2br
        },
        created: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail2024/mixin/product.js
// module id = 227
// module chunks = 0